class CurrencyModal extends HTMLElement {
  constructor() {
    super();
    this.modal = this.querySelector(".currency-modal");
    this.modalContentFront = this.querySelector(".front-modal");
    this.modalContentBack = this.querySelector(".back-modal");
    this.closeSpanX = this.querySelector("span.currency-modal__close-btn");
    this.closeModalBtn = this.querySelector("span.close_modal");
    this.locationFormFront = this.querySelector(
      "form[id=modal--localization][modal-side=front]"
    );
    this.locationFormBack = this.querySelector(
      "form[id=modal--localization][modal-side=back]"
    );
    this.load();
    this.updateSelectedLocale();
  }

  load() {
    this.addListeners();
  }

  updateSelectedLocale() {
    const localeSelector = this.querySelector("[name=locale_code]");
    if (localeSelector) {
      localeSelector.value = window.Shopify.locale;
    }
  }

  addListeners() {
    this.closeSpanX.addEventListener("click", () => {
      this.modal.style.display = "none";
      document.body.classList.remove("overflow-hidden");
    });
    this.closeModalBtn.addEventListener("click", () => {
      this.modal.style.display = "none";
      document.body.classList.remove("overflow-hidden");
    });
    window.onclick = function (event) {
      const modal = document.querySelector(".currency-modal");
      if (event.target === modal) {
        modal.style.display = "none";
        document.body.classList.remove("overflow-hidden");
      }
    };
  }

  setLocationCookies() {
    let activeForm;
    if (window.getComputedStyle(this.modalContentFront).display !== "none") {
      activeForm = this.locationFormFront;
    } else if (
      window.getComputedStyle(this.modalContentBack).display !== "none"
    ) {
      activeForm = this.locationFormBack;
    }
    const formData = new FormData(activeForm);
    for (let [key, value] of formData.entries()) {
      if (key === "country_code") {
        setCookie("country_code", value, 365);
      } else if (key === "locale_code") {
        setCookie("locale_code", value, 365);
        setCookie("i18next", value, 365);
      }
    }
  }

  showModal() {
    this.modalContentFront.style.display = "none";
    this.modal.style.display = "flex";
    this.modalContentBack.style.display = "block";
    document.body.classList.add("overflow-hidden");
  }
}

customElements.define("modal-currency-root", CurrencyModal);

function setCookies() {
  const selectedCountry = document.querySelector('[name="country_code"]').selectedOptions[0].dataset.countryName;
  window?.sendEvent("navigation_country_select", { event_detail: selectedCountry })
  const modalElement = document.querySelector("#modal-currency-root");
  modalElement.setLocationCookies();
}

document
  .querySelectorAll('[name="country_code"]')
  .forEach((localizationModal) => {
    localizationModal.addEventListener("change", function (event) {
      const flagList = localizationModal
        .closest("form")
        .querySelectorAll(`.flag_list span`);
      const currentFlag = event.target.value;
      flagList.forEach((node) => {
        if (
          node.dataset &&
          node.dataset.country &&
          node.dataset.country === currentFlag
        ) {
          node.style.display = "block";
        } else {
          node.style.display = "none";
        }
      });
    });
  });

function autoRedirectMarket() {
  const query = new URLSearchParams(document.location.search)
  const country = query.get('country')

  if (window.Shopify.country === 'MX' && !country) {
    document.location = 'https://bloomnu.mx/'
    return
  }

  if (country && country.toUpperCase() !== window.Shopify.country.toUpperCase()) {
    const form = document.createElement('form')
    form.method = 'post'
    form.action = '/localization'
    const methodInput = document.createElement('input')
    methodInput.type = 'hidden'
    methodInput.name = '_method'
    methodInput.value = 'put'

    const countryInput = document.createElement('input')
    countryInput.type = 'hidden'
    countryInput.name = 'country_code'
    countryInput.value = query.get('country')

    form.submit()
  }

}

autoRedirectMarket()
